import React from "react";
import PropTypes from "prop-types";
import { Plus } from "lucide-react";

import { TabSetsLevels, UIButton } from "../../../ui";
import { TIMESHEET_SLOT_TABS } from "./constants";
import EventTimesheetShiftsTable from "./EventTimesheetShiftsTable";
import EventTimesheetTrainingsTable from "./EventTimesheetTrainingsTable";

import "./EventTimesheet.scss";

const EventTimesheetApplicantPanel = ({
  copy,
  timeSheetCopy,
  sharedLabels,
  applicantsLabels,
  lang,
  activeTab,
  onTabChange,
  canAddSlot,
  onAddSlot,
  shiftsRows,
  shiftsLoading,
  shiftsPage,
  shiftsPageSize,
  shiftsTotal,
  shiftsPages,
  shiftsRangeFrom,
  shiftsRangeTo,
  shiftsRowActions,
  onShiftRowAction,
  onShiftsPageChange,
  onShiftsPageSizeChange,
  trainingsRows,
  trainingsLoading,
  trainingsRowActions,
  onTrainingRowAction,
}) => {
  const tabs = [
    { value: TIMESHEET_SLOT_TABS.shifts, label: copy.shiftsTab },
    { value: TIMESHEET_SLOT_TABS.trainings, label: copy.trainingsTab },
  ];

  return (
    <div className="event-timesheet event-timesheet--applicant">
      <div className="event-timesheet__slot-header">
        <TabSetsLevels
          tabs={tabs}
          value={activeTab}
          onChange={onTabChange}
          className="event-timesheet__slot-tabs"
        />
        {canAddSlot ? (
          <UIButton
            type="button"
            variant="primary"
            appearance="outline"
            size="large"
            startIcon={<Plus size={18} />}
            onClick={onAddSlot}
            className="event-timesheet__add-slot-btn"
          >
            {timeSheetCopy.addStatus}
          </UIButton>
        ) : null}
      </div>

      {activeTab === TIMESHEET_SLOT_TABS.shifts ? (
        <EventTimesheetShiftsTable
          copy={copy}
          timeSheetCopy={timeSheetCopy}
          sharedLabels={sharedLabels}
          applicantsLabels={applicantsLabels}
          lang={lang}
          rows={shiftsRows}
          isLoading={shiftsLoading}
          page={shiftsPage}
          pageSize={shiftsPageSize}
          total={shiftsTotal}
          pages={shiftsPages}
          rangeFrom={shiftsRangeFrom}
          rangeTo={shiftsRangeTo}
          rowActions={shiftsRowActions}
          onRowAction={onShiftRowAction}
          onPageChange={onShiftsPageChange}
          onPageSizeChange={onShiftsPageSizeChange}
        />
      ) : (
        <EventTimesheetTrainingsTable
          copy={copy}
          timeSheetCopy={timeSheetCopy}
          sharedLabels={sharedLabels}
          lang={lang}
          rows={trainingsRows}
          isLoading={trainingsLoading}
          rowActions={trainingsRowActions}
          onRowAction={onTrainingRowAction}
        />
      )}
    </div>
  );
};

EventTimesheetApplicantPanel.propTypes = {
  copy: PropTypes.object.isRequired,
  timeSheetCopy: PropTypes.object.isRequired,
  sharedLabels: PropTypes.object.isRequired,
  applicantsLabels: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  activeTab: PropTypes.oneOf(Object.values(TIMESHEET_SLOT_TABS)).isRequired,
  onTabChange: PropTypes.func.isRequired,
  canAddSlot: PropTypes.bool,
  onAddSlot: PropTypes.func,
  shiftsRows: PropTypes.array,
  shiftsLoading: PropTypes.bool,
  shiftsPage: PropTypes.number,
  shiftsPageSize: PropTypes.number,
  shiftsTotal: PropTypes.number,
  shiftsPages: PropTypes.number,
  shiftsRangeFrom: PropTypes.number,
  shiftsRangeTo: PropTypes.number,
  shiftsRowActions: PropTypes.array,
  onShiftRowAction: PropTypes.func,
  onShiftsPageChange: PropTypes.func.isRequired,
  onShiftsPageSizeChange: PropTypes.func.isRequired,
  trainingsRows: PropTypes.array,
  trainingsLoading: PropTypes.bool,
  trainingsRowActions: PropTypes.array,
  onTrainingRowAction: PropTypes.func,
};

EventTimesheetApplicantPanel.defaultProps = {
  canAddSlot: false,
  onAddSlot: undefined,
  shiftsRows: [],
  shiftsLoading: false,
  shiftsPage: 1,
  shiftsPageSize: 10,
  shiftsTotal: 0,
  shiftsPages: 1,
  shiftsRangeFrom: 0,
  shiftsRangeTo: 0,
  shiftsRowActions: [],
  onShiftRowAction: undefined,
  trainingsRows: [],
  trainingsLoading: false,
  trainingsRowActions: [],
  onTrainingRowAction: undefined,
};

export default EventTimesheetApplicantPanel;
